var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ImportTask_1;
import { DateConverter, JSON, JsonConverter, JsonDiscriminatorProperty, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { OrgPlan } from '@symon-ai/wisepipe-user';
import '@symon-ai/wisepipe-common'; // force import for JsonSchemaV2
import { Utils } from '@symon-ai/wisepipe-common';
import './multipartCopyObject';
import { importTaskSchemaValidation } from '../validations.generated';
export var DataCategory;
(function (DataCategory) {
    DataCategory["DataSource"] = "dataSource";
    DataCategory["UnitTestDataSource"] = "unitTestDataSource";
    DataCategory["UnitTestSnapshot"] = "unitTestSnapshot";
})(DataCategory || (DataCategory = {}));
export var ImportStatus;
(function (ImportStatus) {
    ImportStatus["Waiting"] = "waiting";
    ImportStatus["Running"] = "running";
    ImportStatus["Completed"] = "completed";
    ImportStatus["Failed"] = "failed";
    ImportStatus["Cancelled"] = "cancelled";
})(ImportStatus || (ImportStatus = {}));
export var ImportOperation;
(function (ImportOperation) {
    ImportOperation["New"] = "new";
    ImportOperation["Append"] = "append";
    ImportOperation["Overwrite"] = "overwrite";
})(ImportOperation || (ImportOperation = {}));
export const importTaskSchema = {
    $id: 'urn:wisepipe-common-data:ImportTask',
    type: 'object',
    properties: {
        userID: { type: 'string', format: 'uuid' },
        userName: { type: 'string' },
        userEmail: { type: 'string' },
        orgID: { type: 'string', format: 'uuid' },
        orgPlan: { type: 'string', enum: Object.values(OrgPlan) },
        importID: { type: 'string', uid: 9 },
        operation: {
            type: 'string',
            enum: Object.values(ImportOperation)
        },
        originID: { type: 'string', uid: 9 },
        firstDataSourceID: { type: 'string', uid: 9 },
        csvExtractionFolder: { $ref: 'urn:wisepipe-common:S3File' },
        status: { type: 'string', enum: Object.values(ImportStatus) },
        startTime: { type: 'string', format: 'date-time' },
        endTime: { type: 'string', format: 'date-time' },
        error: { type: 'object' },
        isParquet: { type: 'boolean' },
        multipartCopyObjects: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-data:MultipartCopyObject' }
        },
        fileSize: { type: 'number' },
        generateSampleFiles: { type: 'boolean' },
        sampleFilesGenerated: { type: 'boolean' },
        quickImport: { type: 'boolean' },
        dataCategory: { type: 'string', enum: Object.values(DataCategory) },
        importFileCopyFolder: { $ref: 'urn:wisepipe-common:S3File' },
        sourceFileName: { type: 'string' },
        isDecimalOrg: { type: 'boolean' }
    },
    // status drives required fields
    if: { properties: { status: { const: ImportStatus.Completed } } },
    then: { required: ['endTime'] },
    else: {
        if: { properties: { status: { const: ImportStatus.Cancelled } } },
        then: { required: ['endTime'] },
        else: {
            if: { properties: { status: { const: ImportStatus.Failed } } },
            then: { required: ['error', 'endTime'] }
        }
    },
    required: ['userID', 'orgID', 'importID', 'operation', 'originID', 'csvExtractionFolder', 'status', 'startTime']
};
/**
 * Represents an instance of an import job that is
 * being executed according to an dataSourceOrigin's config.
 * Contains details regarding the actual execution of the import.
 */
let ImportTask = ImportTask_1 = class ImportTask {
    constructor(orgID, userID, importID, operation, originID, csvExtractionFolder, status, startTime, endTime, error, isParquet = false, firstDataSourceID, orgPlan, userName, userEmail, multipartCopyObjects, fileSize, generateSampleFiles, sampleFilesGenerated, quickImport, dataCategory, importFileCopyFolder, isDecimalOrg) {
        this.orgID = orgID;
        this.userID = userID;
        this.userName = userName;
        this.userEmail = userEmail;
        this.orgPlan = orgPlan;
        this.importID = importID;
        this.operation = operation;
        this.originID = originID;
        this.firstDataSourceID = firstDataSourceID;
        this.csvExtractionFolder = csvExtractionFolder;
        this.status = status;
        this.startTime = startTime;
        this.endTime = endTime;
        this.error = error;
        this.isParquet = isParquet;
        // newly added for handling multipart copy for large files in multpartCopyWorker
        this.multipartCopyObjects = multipartCopyObjects;
        this.fileSize = fileSize;
        this.generateSampleFiles = generateSampleFiles ?? false;
        this.sampleFilesGenerated = sampleFilesGenerated ?? false;
        this.quickImport = quickImport ?? false;
        if (dataCategory !== undefined)
            this.dataCategory = dataCategory;
        this.importFileCopyFolder = importFileCopyFolder;
        this.isDecimalOrg = isDecimalOrg ?? false;
        JSON.validate(this, ImportTask_1);
    }
    static newID() {
        return Utils.newID();
    }
    static bufferID(importID) {
        return Utils.base64StringToBuffer(importID);
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], ImportTask.prototype, "startTime", void 0);
__decorate([
    JsonConverter(new DateConverter('date-time'))
], ImportTask.prototype, "endTime", void 0);
ImportTask = ImportTask_1 = __decorate([
    JsonSchemaV2(importTaskSchema, importTaskSchemaValidation),
    JsonDiscriminatorProperty('dataCategory')
], ImportTask);
export { ImportTask };
//# sourceMappingURL=importTask.js.map